import { create } from 'zustand';

interface DeletedListsState {
  /** Lists deleted while this tab was open (their pages say so instead of asking the server again). */
  ids: ReadonlySet<string>;
  add: (id: string) => void;
}

export const useDeletedLists = create<DeletedListsState>((set) => ({
  ids: new Set(),
  add: (id) => set((state) => ({ ids: new Set([...state.ids, id]) })),
}));
